<template>
  <div>
    <span class>Chọn danh mục Thuốc</span>
    <div class="cs-relative">
      <div class="cs-relative" v-click-outside="handleClose">
        <el-input class="cs-input" v-model="searchQuery" @input="handleSearch" autocomplete="off"
          placeholder="Nhập mã, tên danh mục thuốc" ref="inputRef" id="inputRef" clearable
          :disabled="!inventoryInfo"></el-input>
      </div>
      <div v-show="isShowOptions" class="cs-table">
        <div class="table-header-container">
          <div class="row cs-header" style="display: flex;">
            <div class="cs-col cs-border-right cs-header-item">Mã thuốc</div>
            <div class="cs-col cs-border-right cs-header-item">Tên thuốc</div>
            <div v-if="hasQualityColumn" class="cs-col cs-border-right cs-header-item">Hàm lượng</div>
            <div v-if="hasActiveIngredientColumn" class="cs-col cs-border-right cs-header-item">Hoạt chất</div>
            
            <div class="cs-col cs-header-item">Đơn vị</div>
          </div>
        </div>
        <div class="table-container" v-loading="isLoading">
          <div class="cs-body" id="tableID">
            <div v-for="item in medicines" :key="item.id" @click="handleSelectedItem(item)" class="row cs-option"
              style="display: flex;" :set="(medicineInfo = item.product_info)">
              <div class="cs-col cs-border-right cs-item">{{ `#${medicineInfo.product_code}` }}</div>
              <div class="cs-col cs-border-right cs-item">{{ medicineInfo.name }}</div>
              <div v-if="hasQualityColumn"
                class="cs-col cs-border-right cs-item">{{ medicineInfo.quality || '' }}</div>
              <div v-if="hasActiveIngredientColumn"
                class="cs-col cs-border-right cs-item">{{ getActiveIngredient(medicineInfo) || '' }}</div>
              <div class="cs-col cs-item">{{ getUnit(medicineInfo) }}</div>
            </div>
            <div class="flex items-center justify-center py-3" v-if="medicines.length === 0 && !isLoading">
              <span>Không có dữ liệu</span>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import appUtils from '@/utils/appUtils'
import { debounce } from 'lodash'
import { mixinHasFeatures } from '@/utils/mixinHasFeatures'

export default {
  name: 'SelectMedicine',
  mixins: [mixinHasFeatures],
  props: {
    medicine: Object,
    inventoryMedicine: Number,
    clearCount: Number,
    listInventory: Array,
    isPhieuLinh: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      isShowOptions: false,
      medicines: [],
      currentPage: 1,
      totalPage: 0,
      searchQuery: null,
      limit: 10,
      isLoading: false
    }
  },
  computed: {
    inventoryInfo () {
      this.isShowOptions = true
      this.medicines = []
      return this.listInventory?.find(
        item => item?.id === this.inventoryMedicine
      )
    },
    hasQualityColumn () {
      if (!this.medicines || !this.medicines.length) return false
      return this.medicines.some(m => {
        const q = m?.product_info?.quality
        return q !== null && q !== undefined && String(q).trim() !== ''
      })
    },
    hasActiveIngredientColumn () {
      if (!this.medicines || !this.medicines.length) return false
      return this.medicines.some(m => {
        const ai = this.getActiveIngredient(m?.product_info || {})
        return ai !== null && ai !== undefined && String(ai).trim() !== ''
      })
    }
  },
  watch: {
    isShowOptions: {
      handler: function (isShow) {
        if (isShow === true) {
          const table = document.querySelector('#tableID')
          if (table) {
            table.addEventListener('scroll', e => {
              if (
                table.scrollTop + table.clientHeight >=
                table.scrollHeight - 10 &&
                !this.isLoading
              ) {
                const nextPage = this.currentPage + 1

                if (nextPage <= this.totalPage) {
                  this.currentPage = nextPage
                  this.handleGetMedicines(true)
                }
              }
            })
          }
        }
      },
      deep: true
    },
    clearCount () {
      this.handleClearSelected()
    },
    medicine: {
      deep: true,
      handler (data) {
        this.isShowOptions = true
        if (data) this.searchQuery = this.handleGetMedicineName(data)
        else this.searchQuery = ''
      }
    },
    inventoryMedicine (value) {
      this.currentPage = 1
      this.limit = 10
      this.isShowOptions = true
      this.handleGetMedicines()
    },
    searchQuery () {
      this.isShowOptions = true
    }
  },

  created () {

  },
  mounted () {
    if (this.medicine?.product_info?.id) {
      this.searchQuery = this.handleGetMedicineName(this.medicine)
    }
    const input = document.getElementById('inputRef')
    input.addEventListener('click', () => {
      this.isShowOptions = !this.isShowOptions
    })
  },
  methods: {
    handleClose () {
      this.isShowOptions = false
    },
    handleSearch (value) {
      this.searchQuery = value
      this.currentPage = 1

      this.handleDebounce()
    },
    handleGetMedicines (isPush) {
      if (this.inventoryInfo?.isExternal) {
        this.getPharmasExternal(isPush)
      } else {
        this.fetchPharmaProducts(isPush)
      }
    },
    handleDebounce: debounce(function () {
      this.handleGetMedicines()
    }, 100),
    handleSelectedItem (item) {
      const hasData = this.medicine?.id === item?.id
      if (hasData) return
      this.searchQuery = this.handleGetMedicineName(item)
      this.$emit('onUpdateMedicine', item)
    },
    handleClearSelected () {
      this.searchQuery = null
      this.$refs.inputRef.nodeValue = ''
      this.$emit('onClearMedicine')

      this.isShowOptions = true
      this.handleGetMedicines()
    },
    getActiveIngredient (product) {
      return product?.isExternal
        ? product?.active_ingredient || ''
        : product?.active_ingredient_info?.name || product?.active_ingredient || ''
    },
    getUnit (product) {
      return product?.isExternal
        ? product?.unit_id
        : product?.unit_info?.name || product?.unit_id || ''
    },
    formatPrice (price) {
      return appUtils.numberFormat(price, 'VNĐ')
    },
    async fetchPharmaProducts (isPush) {
      if (!this.inventoryInfo) return
      this.isLoading = true

      try {
        const inventoryId = this.inventoryInfo.id
        if (!inventoryId) return
        let responseData = []
        let totalPage = 0
        if (this.hasEHCConnect) {
          const params = {
            is_thuoc: true,
            is_phieu_linh: this.isPhieuLinh,
            medicine_store_id: inventoryId
          }
          const response = await this.$rf
            .getRequest('DoctorRequest')
            .getMedicinesEHC(params)

          responseData = (response.data || []).map(item => ({
            id: item.national_pharma_code,
            product_info: {
              product_code: item.national_pharma_code,
              name: item.name,
              quality: item.concentration,
              active_ingredient: item.active_ingredient,
              unit_id: item.unit_name,
              packing: item.packing,
              registration_number: item.pharma_reg_number,
              side_effect: item.side_effect,
              available_quantity: item.quantity,
              isExternal: false
            }
          }))
          totalPage = 1
        } else {
          const params = {
            id: inventoryId,
            keyword: this.searchQuery,
            page_num: this.currentPage,
            page_size: this.limit,
            sort_by: 'id',
            order: 'desc'
          }

          const response = await this.$rf
            .getRequest('DoctorRequest')
            .getMedicines(inventoryId, params)

          responseData = response.data?.data || []
          totalPage = response.data?.page?.total_page || 0
        }

        if (isPush) {
          const oldData = [...this.medicines]
          this.medicines = [...oldData, ...(responseData || [])]
          this.totalPage = totalPage
        } else {
          this.medicines = responseData || []
          this.totalPage = totalPage
        }
        this.isLoading = false
      } catch (error) {
        this.isLoading = false
      }
    },
    async getPharmasExternal (isPush) {
      this.isLoading = true
      const params = {
        limit: this.limit,
        page: this.currentPage
      }
      if (this.searchQuery) {
        params.name = this.searchQuery
      }

      await this.$rf
        .getRequest('DoctorRequest')
        .getPharmasUniversal(params)
        .then(res => {
          let mapData = []
          if (res?.data) {
            if (isPush) {
              const newData = res.data.map(x => ({
                ...x,
                label: `${x.active_ingredient}(${x.name}), ${x.unit_name}`
              }))
              const oldData = [...this.medicines]
              mapData = [...oldData, ...(newData || [])]
            } else {
              mapData = res.data || []
            }

            this.medicines = mapData?.map(item => {
              return {
                ...item,
                product_info: {
                  product_code: item?.national_pharma_code,
                  name: item?.name,
                  quality:
                    item?.concentration === null ? item?.quality : item?.concentration,
                  active_ingredient: item?.active_ingredient,
                  unit_id: item?.unit_name,
                  isExternal: true
                }
              }
            })
            this.totalPage = res?.last_page || 0

            this.isLoading = false
          }
        })
        .catch(e => {
          this.isLoading = false
        })
    },
    handleGetMedicineName (medicine) {
      const medicineName = medicine?.name || medicine?.product_info?.name || ''
      const activeIngredient =
        medicine?.active_ingredient ||
        medicine?.product_info?.active_ingredient_info?.name ||
        ''
      const quality =
        medicine?.concentration || medicine?.product_info?.quality || ''

      return `${activeIngredient} ${quality} ${medicineName ? `(${medicineName})` : ''
      }`
    }
  }
}
</script>

<style lang="scss" scoped>
.cs_down_icon {
  display: block;
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
}

.cs-relative {
  position: relative;
  z-index: 100000;
}

.table-container {
  padding-right: 5px;
  border-bottom: 1px solid #9b9b9b;
  height: auto;
  min-height: 0;
  max-height: 200px;
}

.table-header-container {
  padding-right: 5px;
  border-bottom: 1px solid #9b9b9b;
}

.cs-table {
  display: block;
  position: absolute;
  top: 40px;
  left: 0;
  width: 100%;
  background-color: white;
  z-index: 10;
  border: 1px solid #9b9b9b;
  border-bottom: unset;
  margin: 0;
  height: auto;
  min-height: 0;
  max-height: 200px;
  border-radius: 0;
  z-index: 100000;
}

.cs-header {

  margin: 0;
  display: flex;
}

.cs-col {
  flex: 1;
  min-width: 0;
  word-break: break-word;
  white-space: normal;
}

.cs-border-right {
  border-right: 1px solid #9b9b9b;
}

.cs-border-bottom {
  border-bottom: 1px solid #9b9b9b;
}

.cs-header-item {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px;
}

.cs-item {
  padding: 8px;
  word-break: break-word;
  white-space: normal;
}

.cs-option:hover {
  cursor: pointer;
  background-color: rgba(29, 68, 177, 0.12);
}

.cs-option {
  margin: 0;
}

.cs-body {
  overflow-y: scroll;
  height: auto;
  min-height: 0;
  max-height: 200px;
  margin: 0;
  margin-right: -5px;
  position: relative;

  &::-webkit-scrollbar {
    background-color: red;
    width: 5px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background: #888;
  }
}

::v-deep {
  .cs-input {
    .el-input__inner {
      padding-right: 45px;
    }
  }
}
</style>